
import React, { Component } from 'react';

import {
    createRecordingDialogEvent,
    sendAnalytics
} from '../../../analytics';
import { ColorSchemeRegistry } from '../../../base/color-scheme';
import {
    _abstractMapStateToProps
} from '../../../base/dialog';
import { translate } from '../../../base/i18n';
import {
    Button,
    Container,
    Image,
    LoadingIndicator,
    Switch,
    Text
} from '../../../base/react';
import { connect } from '../../../base/redux';
import { ColorPalette, StyleType } from '../../../base/styles';
import { checkIfReactNative } from '../../../base/util/checkOS';
import { isVpaasMeeting } from '../../../billing-counter/functions';
import { authorizeDropbox, updateDropboxToken } from '../../../dropbox';
import { authorizeOneDrive, updateOneDriveToken } from '../../../onedrive';
import { RECORDING_TYPES } from '../../constants';
import { getRecordingDurationEstimation } from '../../functions';

import { AWS_LOGO, DROPBOX_LOGO, ICON_SHARE, JITSI_LOGO, MH_LOGO, ONEDRIVE_LOGO } from './styles';


const COLOR_FFFFFF = '#ffffff';

const _inlineStyles = {
    _s0: { opacity: 0 },
    _s1: {
        alignSelf: 'center'
    },
    _storageFullText: {
        color: ColorPalette.red
    }
};

// const textStyle = {
//     width: '100%',
//     justifyContent: 'center',
//     alignItems: 'center',
//     marginTop: '10px'
// };
const fixStyles = {
    width: '100%',
    display: 'flex',
    flex: 'auto',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center'
};

const fixStyles1 = {
    display: 'flex',
    alignItems: 'center'
};

type Props = {

    /**
     * Style of the dialogs feature.
     */
    _dialogStyles: StyleType,

    /**
     * The color-schemed stylesheet of this component.
     */
    _styles: StyleType,

    /**
     * The redux dispatch function.
     */
    dispatch: Function,

    /**
     * Whether to show file recordings service, even if integrations
     * are enabled.
     */
    fileRecordingsServiceEnabled: boolean,

    /**
     * Whether to show the possibility to share file recording with other people (e.g. Meeting participants), based on
     * the actual implementation on the backend.
     */
    fileRecordingsServiceSharingEnabled: boolean,

    storageSpace: ?Object,

    /**
     * If true the content related to the integrations will be shown.
     */
    integrationsEnabled: boolean,

    /**
     * IsAws.
     */
    isAws: Boolean,

    /**
     * Whether selected recording storage is full.
     */
    isStorageFull: boolean,

    /**
     * <tt>true</tt> if we have valid oauth token.
     */
    isTokenValid: boolean,

    /**
     * <tt>true</tt> if we are in process of validating the oauth token.
     */
    isValidating: boolean,

    /**
     * Whether or not the current meeting is a vpaas one.
     */
    isVpaas: boolean,

    /**
     * The function will be called when there are changes related to the
     * switches.
     */
    onChange: Function,

    /**
     * Callback to be invoked on sharing setting change.
     */
    onSharingSettingChanged: Function,

    /**
     * The currently selected recording service of type: RECORDING_TYPES.
     */
    selectedRecordingService: ?string,

    /**
     * Boolean to set file recording sharing on or off.
     */
    sharingSetting: boolean,


    /**
     * Token.
     */
    _token: ?String,

    /**
     * OneDrive token.
     */
    _oneDriveToken: ?String,

    /**
     * Number of MiB of available space in user's Dropbox account.
     */
    spaceLeft: ?number,

    /**
     * Storage type for recording.
     */
    storageType: ?String,

    /**
     * The translate function.
     */
    t: Function,

    /**
     * The display name of the user's Dropbox account.
     */
    userName: ?string,

    /**
     * OneDrive display name.
     */
    oneDriveUserName: ?string,

    /**
     * OneDrive available space in MB.
     */
    oneDriveSpaceLeft: ?number,

    /**
     * OneDrive owner email.
     */
    oneDriveUserEmail: ?string,

    /**
     * OneDrive storage total in MB.
     */
    oneDriveSpaceTotal: ?number,

    /**
     * OneDrive storage used in MB.
     */
    oneDriveSpaceUsed: ?number,

    sheetColor: ?string
};

/**
 * React Component for getting confirmation to start a file recording session.
 *
 * @augments Component
 */
class StartRecordingDialogContent extends Component<Props> {
    /**
     * Initializes a new {@code StartRecordingDialogContent} instance.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);

        // Bind event handler so it is only bound once for every instance.
        this._onSignIn = this._onSignIn.bind(this);
        this._onSignOut = this._onSignOut.bind(this);
        this._onDropboxSwitchChange = this._onDropboxSwitchChange.bind(this);
        this._onOneDriveSwitchChange = this._onOneDriveSwitchChange.bind(this);
        this._onRecordingServiceSwitchChange = this._onRecordingServiceSwitchChange.bind(this);
    }


    /**
     * Renders the component.
     *
     * @protected
     * @returns {React$Component}
     */
    render() {
        const { _styles: styles } = this.props;

        return (
            <Container
                className = 'recording-dialog'
                style = { styles.container }>
                {this._renderNoIntegrationsContent()}
                {this._renderIntegrationsContent()}
                {this._renderFileSharingContent()}
            </Container>
        );
    }

    /**
     * Renders the file recording service sharing options, if enabled.
     *
     * @returns {React$Component}
     */
    _renderFileSharingContent() {
        const { fileRecordingsServiceSharingEnabled, isVpaas } = this.props;

        if (!fileRecordingsServiceSharingEnabled || isVpaas) {
            return null;
        }

        const {
            _dialogStyles,
            _styles: styles,
            isValidating,
            onSharingSettingChanged,
            selectedRecordingService,
            sharingSetting,
            t
        } = this.props;

        const controlDisabled = selectedRecordingService !== RECORDING_TYPES.MH_REC_SERVICE;
        const _dsTitleText = { ..._dialogStyles.text,
            ...styles.title };
        let mainContainerClasses = 'recording-header recording-header-line';

        if (controlDisabled) {
            mainContainerClasses += ' recording-switch-disabled';
        }

        return (
            <Container
                className = { mainContainerClasses }
                key = 'fileSharingSetting'
                style = { [
                    styles.header,
                    _dialogStyles.topBorderContainer,
                    controlDisabled ? styles.controlDisabled : null
                ] }>
                <Container className = 'recording-icon-container'>
                    <Image
                        className = 'recording-icon'
                        src = { ICON_SHARE }
                        style = { styles.recordingIcon } />
                </Container>
                <Text
                    className = 'recording-title'
                    style = { _dsTitleText }>
                    {t('recording.fileSharingdescription')}
                </Text>
                <Switch
                    className = 'recording-switch'
                    disabled = { controlDisabled || isValidating }
                    onValueChange
                        = { onSharingSettingChanged }
                    style = { styles.switch }
                    trackColor = {{ false: ColorPalette.lightGrey }}
                    value = { !controlDisabled && sharingSetting } />
            </Container>
        );
    }

    /**
     * Renders the content in case no integrations were enabled.
     *
     * @returns {React$Component}
     */
    _renderNoIntegrationsContent() {

        // show the non integrations part only if fileRecordingsServiceEnabled
        // is enabled or when there are no integrations enabled
        if (!(this.props.fileRecordingsServiceEnabled
            || !this.props.integrationsEnabled)) {
            return null;
        }

        const { _dialogStyles, _styles: styles, isValidating, isVpaas, t } = this.props;

        const switchContent
            = this.props.integrationsEnabled
                ? (
                    <Switch
                        className = 'recording-switch'
                        disabled = { isValidating }
                        onValueChange = { this._onRecordingServiceSwitchChange }
                        style = { styles.switch }
                        trackColor = {{ false: ColorPalette.lightGrey }}
                        value = { this.props.selectedRecordingService === RECORDING_TYPES.MH_REC_SERVICE } />
                ) : null;

        const icon = isVpaas ? ICON_SHARE : JITSI_LOGO;
        const label = isVpaas ? t('recording.serviceDescriptionCloud') : t('recording.serviceDescription');
        const _dsTitleText = { ..._dialogStyles.text,
            ...styles.title };

        return (
            <Container
                className = 'recording-header'
                key = 'noIntegrationSetting'
                style = { styles.header }>
                <Container className = 'recording-icon-container'>
                    <Image
                        className = 'recording-icon'
                        src = { icon }
                        style = { styles.recordingIcon } />
                </Container>
                <Text
                    className = 'recording-title'
                    style = { _dsTitleText }>
                    {label}
                </Text>
                {switchContent}
            </Container>
        );
    }

    /**
     * Renders the content in case integrations were enabled.
     *
     * @protected
     * @returns {React$Component}
     */
    _renderIntegrationsContent() {
        if (!this.props.integrationsEnabled) {
            return null;
        }

        const {
            _dialogStyles,
            _styles: styles,
            isTokenValid,
            isValidating,
            isStorageFull,
            t,
            isAws,
            storageType,
            storageSpace: {
                s3_free_space = null,
                s3_used_space = null
            },
            selectedRecordingService
        } = this.props;
        const sheetColorStyle = this.props.sheetColor ? { color: this.props.sheetColor } : null;
        const sheetColorOrWhiteStyle = { color: this.props.sheetColor || COLOR_FFFFFF };
        const isOneDriveSelected = selectedRecordingService === RECORDING_TYPES.ONEDRIVE;
        const isCustomAwsStorage = isAws && storageType === 'Custom';
        let content = null;
        let switchContent = null;

        if (isValidating && !isAws) {
            content = this._renderSpinner();
            switchContent = <Container className = 'recording-switch' />;
        } else if (isTokenValid && !isAws) {
            content = this._renderSignOut();
            switchContent = (
                <Container className = 'recording-switch'>
                    <Button
                        children = { isOneDriveSelected ? t('recording.oneDriveSignOut') : t('recording.signOut') }
                        labelKey = { isOneDriveSelected ? t('recording.oneDriveSignOut') : t('recording.signOut') }
                        onValueChange = { this._onSignOut }
                        style = { [ styles.signButton, sheetColorStyle ] } />
                </Container>
            );

        } else if (isAws) {

            switchContent = <Container style = { _inlineStyles._s0 } />;
        } else {
            switchContent = (
                <Container className = 'recording-switch'>
                    <Button
                        children = { t('recording.signIn') }
                        labelKey = { t('recording.signIn') }
                        onValueChange = { this._onSignIn }
                        style = { [ styles.signButton, sheetColorOrWhiteStyle ] } />
                </Container>
            );
        }

        if (this.props.fileRecordingsServiceEnabled) {
            switchContent = (
                <Switch
                    className = 'recording-switch'
                    disabled = { isValidating }
                    onValueChange = { isOneDriveSelected ? this._onOneDriveSwitchChange : this._onDropboxSwitchChange }
                    style = { styles.switch }
                    trackColor = {{ false: ColorPalette.lightGrey }}
                    value = { this.props.selectedRecordingService
                        === (isOneDriveSelected ? RECORDING_TYPES.ONEDRIVE : RECORDING_TYPES.DROPBOX) } />
            );
        }


        return (
            <Container>
                <Container
                    className = 'recording-header'

                    style = { [ styles.header, _inlineStyles._s1 ] }>
                    <Container style = { checkIfReactNative() ? styles.nativeTextFix : fixStyles }>
                        <Container
                            style = { checkIfReactNative() ? styles.nativeTextFix : fixStyles1 }>
                            <Container
                                className = 'recording-icon-container'>
                                <Image
                                    className = { isCustomAwsStorage ? 'recording-icon-aws' : 'recording-icon' }
                                    src = { isCustomAwsStorage ? AWS_LOGO : isAws ? MH_LOGO : isOneDriveSelected ? ONEDRIVE_LOGO : DROPBOX_LOGO }

                                    style = { styles?.recordingIcon } />
                            </Container>
                            <Text
                                className = 'recording-title'
                                style = {{
                                    ..._dialogStyles.text,
                                    ...styles.title,
                                    ...sheetColorStyle
                                }}>
                                {isAws
                                    ? storageType === 'Custom'
                                        ? t('dialog.customAwsRecording')
                                        : t('dialog.meetHourRecording')
                                    : isOneDriveSelected
                                        ? t('recording.authOneDriveText')
                                        : t('recording.authDropboxText')}
                            </Text>
                        </Container>
                        {switchContent}
                        {s3_free_space !== null && s3_free_space !== undefined && <Container>
                            <Text
                                style = {{
                                    ..._inlineStyles._s1,
                                    ...sheetColorStyle
                                }}>
                                {'\n'}
                                {
                                    t('recording.availableS3Space', {
                                        s3_free_space,
                                        s3_used_space
                                    })
                                }
                            </Text>
                        </Container>
                        }
                        {isStorageFull && <Container>
                            <Text
                                style = {{
                                    ..._inlineStyles._s1,
                                    ...sheetColorStyle,
                                    ..._inlineStyles._storageFullText
                                }}>
                                {'\n'}
                                {t('recording.storageFullDescription')}
                            </Text>
                        </Container>}
                    </Container>
                </Container>
                <Container
                    className = 'authorization-panel'>
                    {content}
                </Container>
            </Container>
        );
    }

    _onDropboxSwitchChange: () => void;
    _onOneDriveSwitchChange: () => void;
    _onRecordingServiceSwitchChange: () => void;

    /**
     * Handler for onValueChange events from the Switch component.
     *
     * @returns {void}
     */
    _onRecordingServiceSwitchChange() {
        const {
            isTokenValid,
            onChange,
            selectedRecordingService
        } = this.props;

        // act like group, cannot toggle off
        if (selectedRecordingService
            === RECORDING_TYPES.MH_REC_SERVICE) {
            return;
        }

        onChange(RECORDING_TYPES.MH_REC_SERVICE);

        if (isTokenValid) {
            this._onSignOut();
        }
    }

    /**
     * Handler for onValueChange events from the Switch component.
     *
     * @returns {void}
     */
    _onDropboxSwitchChange() {
        const {
            isTokenValid,
            onChange,
            selectedRecordingService
        } = this.props;

        // act like group, cannot toggle off
        if (selectedRecordingService
            === RECORDING_TYPES.DROPBOX) {
            return;
        }

        onChange(RECORDING_TYPES.DROPBOX);

        if (!isTokenValid) {
            this._onSignIn();
        }
    }

    /**
     * Handler for onValueChange events from the OneDrive switch.
     *
     * @returns {void}
     */
    _onOneDriveSwitchChange() {
        const {
            isTokenValid,
            onChange,
            selectedRecordingService
        } = this.props;

        if (selectedRecordingService === RECORDING_TYPES.ONEDRIVE) {
            return;
        }

        onChange(RECORDING_TYPES.ONEDRIVE);

        if (!isTokenValid) {
            this._onSignIn();
        }
    }

    /**
     * Renders a spinner component.
     *
     * @returns {React$Component}
     */
    _renderSpinner() {
        return (
            <LoadingIndicator
                isCompleting = { false }
                size = 'small' />
        );
    }

    /**
     * Renders the screen with the account information of a logged in user.
     *
     * @returns {React$Component}
     */
    _renderSignOut() {
        const {
            _styles: styles,
            fileRecordingsServiceEnabled,
            oneDriveSpaceLeft,
            oneDriveSpaceTotal,
            oneDriveSpaceUsed,
            oneDriveUserEmail,
            oneDriveUserName,
            selectedRecordingService,
            spaceLeft,
            isStorageFull,
            t,
            userName
        } = this.props;
        const isOneDriveSelected = selectedRecordingService === RECORDING_TYPES.ONEDRIVE;
        const resolvedSpaceLeft = isOneDriveSelected ? oneDriveSpaceLeft : spaceLeft;
        const resolvedUserName = isOneDriveSelected ? oneDriveUserName : userName;
        const resolvedUserEmail = isOneDriveSelected ? oneDriveUserEmail : undefined;
        const duration = getRecordingDurationEstimation(resolvedSpaceLeft);

        const styleArray = [];

        styles?.text && styleArray.push(styles.text);
        this.props?.sheetColor && styleArray.push({
            color: this.props.sheetColor ? this.props.sheetColor : null
        });
        const mergedTextStyle = styleArray.length ? Object.assign({}, ...styleArray) : null;


        return (
            <Container>
                <Container
                    className = 'logged-in-panel'
                    style = { styles.loggedIn }>
                    <Container>
                        <Text
                            style = { mergedTextStyle }>
                            {isOneDriveSelected
                                ? resolvedUserEmail
                                    ? t('recording.oneDriveUserIdentity', {
                                        email: resolvedUserEmail,
                                        name: resolvedUserName
                                    })
                                    : t('recording.oneDriveUserName', { name: resolvedUserName })
                                : t('recording.loggedIn', { userName: resolvedUserName })}
                        </Text>
                    </Container>
                    <Container>
                        <Text
                            style = { mergedTextStyle }>
                            {isOneDriveSelected
                                ? t('recording.oneDriveSpaceLeft', { spaceLeft: resolvedSpaceLeft })
                                : t('recording.availableSpace', {
                                    spaceLeft: resolvedSpaceLeft,
                                    duration
                                })}
                        </Text>
                    </Container>
                    {isOneDriveSelected && oneDriveSpaceTotal !== undefined && oneDriveSpaceUsed !== undefined && (
                        <Container>
                            <Text
                                style = { mergedTextStyle }>
                                {t('recording.oneDriveStorageBreakdown', {
                                    available: oneDriveSpaceLeft,
                                    total: oneDriveSpaceTotal,
                                    used: oneDriveSpaceUsed
                                })}
                            </Text>
                        </Container>
                    )}
                    {isStorageFull && (
                        <Container>
                            <Text
                                style = {{
                                    ...mergedTextStyle || {},
                                    ..._inlineStyles._storageFullText
                                }}>
                                {t('recording.storageFullDescription')}
                            </Text>
                        </Container>
                    )}
                    {fileRecordingsServiceEnabled && (
                        <Container className = 'recording-switch'>
                            <Button
                                children = { t('recording.signOut') }
                                labelKey = { t('recording.signOut') }
                                onValueChange = { this._onSignOut } />
                        </Container>
                    )}
                </Container>
            </Container>
        );
    }

    _onSignIn: () => void;

    /**
     * Sings in a user.
     *
     * @returns {void}
     */
    _onSignIn() {
        sendAnalytics(createRecordingDialogEvent('start', 'signIn.button'));
        if (this.props.selectedRecordingService === RECORDING_TYPES.ONEDRIVE) {
            this.props.dispatch(authorizeOneDrive());
        } else {
            this.props.dispatch(authorizeDropbox());
        }
    }

    _onSignOut: () => void;

    /**
     * Sings out an user from dropbox.
     *
     * @returns {void}
     */
    _onSignOut() {
        sendAnalytics(createRecordingDialogEvent('start', 'signOut.button'));
        if (this.props.selectedRecordingService === RECORDING_TYPES.ONEDRIVE) {
            this.props.dispatch(updateOneDriveToken('', '', 0));
        } else {
            this.props.dispatch(updateDropboxToken());
        }
    }
}

/**
 * Maps part of the redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @returns {Props}
 */
function _mapStateToProps(state) {


    return {
        _token: state['features/dropbox'].token,
        _oneDriveToken: state['features/onedrive'].token,
        ..._abstractMapStateToProps(state),
        isVpaas: isVpaasMeeting(state),
        _styles: ColorSchemeRegistry.get(state, 'StartRecordingDialogContent')
    };
}


export default translate(connect(_mapStateToProps)(StartRecordingDialogContent));
